import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class SalaryPrintReport extends Component {
  render() {
    const {
      salaries,
      totalSalaryAmount,
      reportDateStart,
      reportDateEnd,
      salaryMonth,
    } = this.props;
    return (
      <Table celled fixed singleLine>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colspan="6" style={{ textAlign: "center" }}>
              Salary for the month of {salaryMonth}{" "}
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell width={1}>Sr#</Table.HeaderCell>
            <Table.HeaderCell width={8}>Name</Table.HeaderCell>
            <Table.HeaderCell width={2}>Salary Type</Table.HeaderCell>
            <Table.HeaderCell width={2}>Hours</Table.HeaderCell>
            <Table.HeaderCell width={2}>Salary</Table.HeaderCell>
            <Table.HeaderCell width={2}>Generated</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {salaries.map((salary) => (
            <Table.Row>
              <Table.Cell>{salary.sr}</Table.Cell>
              <Table.Cell>{salary.name}</Table.Cell>
              <Table.Cell>{salary.salary_type}</Table.Cell>
              <Table.Cell>{salary.hours}</Table.Cell>
              <Table.Cell>{Math.round(salary.salary)}</Table.Cell>
              <Table.Cell>{salary.salaryGenerated === 1 ? "Y" : ""}</Table.Cell>
            </Table.Row>
          ))}
          <Table.Row>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>

            <Table.Cell>
              <strong>{Math.round(totalSalaryAmount)}</strong>
            </Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}
export default SalaryPrintReport;
